import { ProjectCommunicationService } from '../communication/project-comms.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class ProjectGuard  {
  constructor(private projectService: ProjectCommunicationService, private router: Router) { }
  canActivateChild() {
    if (this.projectService.getProjectLoaded()) {
      return true;
    } else {
      this.router.navigate(['/home']);
    }
    return false;
  }

  canActivate() {
    if (this.projectService.getProjectLoaded()) {
      return true;
    } else {
      this.router.navigate(['/home']);
    }

    return false;
  }
}
